export const USER_STATE = 'USER_STATE';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_CHECKOUT_CART_DATA = 'SET_CHECKOUT_CART_DATA';

export const LOGIN_URL = '/auth/login';

export const FORGOT_PASSWORD_URL = '/forgotPassword';
export const FORGOT_PASSWORD_CONFIRMATION_URL = '/passwordConfirmation';

export const DELIVERY_URL = '/delivery';
export const DELIVERY_DPD_URL = `${DELIVERY_URL}/dpd`;
export const DPD_STEP_1 = 'find-collection-point';
export const DPD_STEP_2 = 'choose-collection-point';
export const DPD_STEP_3 = 'collection-details';
export const DELIVERY_DPD_CHOOSE_URL = `${DELIVERY_DPD_URL}/${DPD_STEP_2}`;

export const SET_CONTACT_DETAILS_STEP = 'SET_CONTACT_DETAILS_STEP';
export const SET_DELIVERY_STEP = 'SET_DELIVERY_STEP';
export const SET_PAYMENTS_STEP = 'SET_PAYMENTS_STEP';
export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_SELECTED_PAYMENT_ACCORDION_MODE = 'SET_SELECTED_PAYMENT_ACCORDION_MODE';

export const CARD_URL = '/billing/card';
export const PAYPAL_URL = '/billing/paypal';
export const AFTERPAY_URL = '/billing/afterpay';
export const KLARNA_URL = '/billing/klarna';
export const APPLE_PAY_URL = '/billing/applepay';
export const GOOGLE_PAY_URL = '/billing/googlepay';

export const PREDEFINED_ADDRESS = 'PredefinedAddressZoneDeliveryModeModel';

export const REMOVED_COUPON = 'REMOVED_COUPON';

export const SET_CART_PAYMENT_INFO = 'SET_CART_PAYMENT_INFO';

export const SET_CART_DELIVERY_ADDRESS = 'SET_CART_DELIVERY_ADDRESS';

export const KLARNA_SDK_URL = 'https://x.klarnacdn.net/kp/lib/v1/api.js';
